export default class Goal {
  constructor() {
    this.segmentGoalId = null;
    this.investmentModelId = null;
    this.investmentModelType = null;
    this.investmentModelName = null;
    this.thumbnailLink = null;
    this.targetDate = null;

    // Extra but needed
    this.isEnable = false;
    this.isEditable = true;
    this.isNew = false;
    this.isLoading = false;
  }

  static make(objMix) {
    const goal = new Goal();

    return Object.assign(goal, objMix);
  }

  static getNewGoal() {
    const newGoal = new Goal();

    newGoal.isNew = true;

    return newGoal;
  }
}
